import grey from 'sushiweb/tokens/color/grey';

export const SampleDataInstruction =
  'Information required is mandatory to upload an employee’s detail';

export const AWW_SNAP = 'Aww Snap!';

export const EMPTY_DATA = 'No data found';

export const sampleTableStyle = {
  headCells: {
    style: {
      background: '#FBFBFB',
      fontWeight: 500,
      fontSize: '1.4rem',
      height: '6.6rem',
      padding: `0 2rem`,
      '&:not(:last-of-type)': {
        borderRightStyle: 'solid',
        borderRightWidth: '1px',
        borderRightColor: grey.z200,
      },
    },
  },
  cells: {
    style: {
      fontSize: '1.4rem',
      padding: `0 2rem`,
      height: '5.8rem',
      '&:not(:last-of-type)': {
        borderRightStyle: 'solid',
        borderRightWidth: '1px',
        borderRightColor: grey.z200,
      },
    },
  },
};

export const customTableStyle = {
  headCells: {
    style: {
      background: 'var(--basewhite-000, #FFF)',
      fontSize: '15px',
      height: '6.2rem',
      padding: `0 1.8rem`,
      fontWeight: 300,
      color: 'var(--coolgreycoolgrey-500, #9197A6)',
    },
  },
  cells: {
    style: {
      height: '6rem',
      fontSize: '14px',
      padding: `0rem 2rem`,
    },
  },
  rows: {
    style: {
      '&:nth-child(odd)': {
        background: 'var(--coolgreycoolgrey-50, #F8F9FC)',
      },
      '&:nth-child(even)': {
        background: 'var(--basewhite-000, #FFF)',
      },
      '&:not(:last-of-type)': {
        borderWidth: '0px',
      },
    },
  },
};

export const sampleEmployeeColumns = [
  {
    name: 'Email Id',
    selector: 'email',
    grow: 2,
  },
  {
    name: 'Employee Name',
    selector: 'name',
    grow: 1.5,
  },
  {
    name: 'Contact',
    selector: 'contact',
    grow: 2,
  },
];

export const sampleEmployeeGroupsColumns = [
  {
    name: 'Email Id',
    selector: 'email',
  },
];

export const sampleEmployeeData = [
  {
    email: 'ankur@zomato.com',
    name: 'Ankur',
    contact: '+919999999999',
  },
];
